import React from "react";
import TopMenu from "Components/TopMenu";
import PrimarySearchBar from "Components/PrimarySearchBar";
import SecondarySearchBar from "Components/SecondarySearchBar";
import PrimarySearchMenu from "Components/PrimarySearchMenu";
import SecondarySearchMenu from "Components/SecondarySearchMenu";
import MapComponent from "Components/MapComponent";
import InfoPane from "Components/InfoPane";
import "Config/chartjs.global";
import MainModal from "Components/MainModal";
import config from "Config";

const hideSecondarySearchBar = ({ domain_data, ui }) =>
  (!domain_data.community_value && domain_data.geo_aggregation == "ste") ||
  ui.search_open == "primary";

const Layout = ({ tree, visible }) => (
  <div id="main-view">
    <TopMenu />
    <PrimarySearchBar tree={tree} />
    <SecondarySearchBar tree={tree} hidden={hideSecondarySearchBar(tree)} />
    <ContentPane
      tree={tree}
      hidden={tree.ui.search_open}
      visible={visible}
      secondarySearchBarVisable={!hideSecondarySearchBar(tree)}
    />
    <PrimarySearchMenu tree={tree} hidden={tree.ui.search_open !== "primary"} />
    <SecondarySearchMenu
      tree={tree}
      hidden={tree.ui.search_open !== "secondary"}
    />
    <MainModal className="black" />
  </div>
);

const height = config.admin_state_acronym === "QLD" ? 176 : 136;

const ContentPane = ({ hidden, tree, visible, secondarySearchBarVisable }) => (
  <div
    hidden={hidden}
    style={
      secondarySearchBarVisable ? { height: `calc(100vh - ${height}px)` } : {}
    }
    id="content-pane"
  >
    <div id="map-pane" className="p-0">
      <MapComponent
        {...tree.map_data}
        visible={visible}
        domain_data={tree.domain_data}
      />
    </div>
    <InfoPane domain_data={tree.domain_data} />
  </div>
);

module.exports = Layout;



// WEBPACK FOOTER //
// ./views/MainView.js